<template>
  <DxPopup title="New Cabinet"
           v-model:visible="popupVisible"
           :show-title="true"
           :show-close-button="true"
           :hide-on-outside-click="true"
           :width="500"
           height="auto"
           container=".cabinet-content-container"
           @showing="resetCabinetData"
  >
    <DxPosition at="center" my="center" collision="fit"/>
    <div class="settings-container settings-card">
      <DxForm v-model:form-data="cabinetData" :show-colon-after-label="false">
        <DxSimpleItem data-field="name" editor-type="dxTextBox" :editor-options="{ maxLength: 32 }">
          <DxRequiredRule message="Name is required"/>
          <DxStringLengthRule :min="2" message="Name must have at least 2 characters"/>
        </DxSimpleItem>

        <DxSimpleItem data-field="description" editor-type="dxTextArea" :editor-options="{ maxLength: 200 }"/>
        <DxItem item-type="button" :button-options="submitButtonOptions"/>
      </DxForm>
    </div>
  </DxPopup>
</template>

<script setup>
  import { DxPopup, DxPosition } from "devextreme-vue/popup";
  import { DxForm, DxItem, DxSimpleItem, DxRequiredRule, DxStringLengthRule } from "devextreme-vue/form";
  import { ref } from "vue";
  import { useCabinetsPageStore } from "@/stores/cabinetsPageStore.js";
  import { useUserStore } from "@/stores/userStore.js";
  import { randomColor } from "@/js-modules/colorPalettes.js";

  const cabinetsPageStore = useCabinetsPageStore()
  const { createCabinet } = cabinetsPageStore

  const userStore = useUserStore()
  const { userId } = userStore

  const emit = defineEmits(['closePopup'])

  const popupVisible = ref(false)
  const cabinetData = ref({})

  const addCabinet = () => {
    const newCabinetData = {
      cabinet: {
        color: randomColor('muted'),
        ...cabinetData.value
      }
    }

    createCabinet(newCabinetData)
    emit('closePopup')
  }

  const submitButtonOptions = {
    text: "Save",
    type: 'action',
    width: '30%',
    onClick: addCabinet
  }

  const resetCabinetData = () => { cabinetData.value = {} }
</script>

<style scoped lang="scss">
  .settings-container {
    background-color: $white-light;
  }
</style>
